export default __webpack_public_path__ + "static/media/EndMillProcessImg.d7fbd826.jpg";